export default {
	root: ({ props }) => ({
		class: [
			// Display and Position
			{
				flex: props.fluid,
				"inline-flex": !props.fluid,
			},
			"max-w-full",
			"relative",

			// Misc
			{ "disabled:bg-transparent select-none pointer-events-none cursor-default": props.disabled },
		],
	}),
	pcInput: ({ props, parent }) => ({
		root: {
			class: [
				// Display
				"flex-auto w-[1%]",

				// Font
				"leading-none text-lg",

				// Colors
				// 'text-surface-600',
				"placeholder:text-olive",
				// 'bg-surface-0',
				"border",
				{ "border-surface-300": !props.invalid },

				// Invalid State
				{ "border-red": props.invalid },

				// Spacing
				"m-0 px-3 py-1",

				// Shape
				"appearance-none disabled:bg-transparent",
				{ "rounded-md": !props.showIcon || props.iconDisplay == "input" },
				{ "rounded-l-md  flex-1 pr-9": props.showIcon && props.iconDisplay !== "input" },
				{ "rounded-md flex-1 pr-9": props.showIcon && props.iconDisplay === "input" },

				// Transitions
				"transition-colors",
				"duration-200",

				// States
				{ "hover:border-primary-emphasis": !props.invalid },
				"focus:outline-olive focus:outline focus:ring-4 focus:ring-olive/25",
				// 'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-500/50',

				// Filled State *for FloatLabel
				{ filled: parent.instance?.$name == "FloatLabel" && props.modelValue !== null },
			],
		},
	}),
	dropdownIcon: {
		class: ["absolute top-[50%] -mt-2", "text-olive", "right-[.75rem]"],
	},
	dropdown: {
		class: [
			"relative w-10",

			// Alignments
			"items-center inline-flex text-center align-bottom justify-center",

			// Shape
			"rounded-r-md",

			// Size
			"px-4 py-3 leading-none",

			// Colors
			"text-primary-inverse",
			"bg-primary",
			"border border-olive",

			// States
			"focus:outline-none focus:outline-offset-0 focus:ring",
			"hover:bg-primary-hover hover:border-primary-hover",
			"focus:ring-primary-400/50",
		],
	},
	inputIconContainer: "absolute cursor-pointer top-1/2 right-3 -mt-3",
	inputIcon: "inline-block text-base",
	panel: ({ props }) => ({
		class: [
			// Display & Position
			{
				absolute: !props.inline,
				"inline-block": props.inline,
			},

			// Size
			{ "w-auto p-2 ": !props.inline },
			{ "min-w-[80vw] w-auto p-2 ": props.touchUI },
			{ "p-2 min-w-full": props.inline },

			// Shape
			"border rounded-lg",
			{
				"shadow-md": !props.inline,
			},

			// Colors
			"bg-beige",
			"border-surface-200",

			//misc
			{ "overflow-x-auto": props.inline },
		],
	}),
	header: {
		class: [
			//Font
			"font-semibold",

			// Flexbox and Alignment
			"flex items-center justify-between",

			// Spacing
			"p-2",
			"m-0",

			// Shape
			"border-b",
			"rounded-t-md",

			// Colors
			"text-olive",
			"bg-surface-0",
			"border-olive",
		],
	},
	title: {
		class: [
			// Text
			"leading-8",
			"mx-auto my-0",
		],
	},
	selectMonth: {
		class: [
			// Font
			"text-base leading-[normal]",
			"font-semibold",

			// Colors
			"text-surface-700",

			// Transitions
			"transition duration-200",

			// Spacing
			"px-1 py-2",
			"m-0",

			// States
			"hover:text-primary-500",

			// Misc
			"cursor-pointer",
		],
	},
	selectYear: {
		class: [
			// Font
			"text-base leading-[normal]",
			"font-semibold",

			// Colors
			"text-surface-700",

			// Transitions
			"transition duration-200",

			// Spacing
			"px-1 py-2",
			"m-0",

			// States
			"hover:text-primary-500",

			// Misc
			"cursor-pointer",
		],
	},
	table: {
		class: [
			// Font
			"text-base leading-none",
			// Size & Shape
			"border-collapse",
			"w-full",

			// Spacing
			"m-0 my-2",
		],
	},
	tableHeaderCell: {
		class: [
			// Spacing
			"p-0 md:p-2",
		],
	},
	weekHeader: {
		class: ["leading-[normal]", "text-surface-600", "opacity-60 cursor-default"],
	},
	weekNumber: {
		class: ["text-surface-600", "opacity-60 cursor-default"],
	},
	weekday: {
		class: [
			// Colors
			"text-olive text-xs",
		],
	},
	dayCell: {
		class: [
			// Spacing
			"p-0 md:p-2",
		],
	},
	weekLabelContainer: {
		class: [
			// Flexbox and Alignment
			"flex items-center justify-center",
			"mx-auto",

			// Shape & Size
			"w-10 h-10",
			"rounded-full",
			"border-transparent border",

			// Colors
			"opacity-60 cursor-default bg-olive",
		],
	},
	dayView: "w-full",
	day: ({ context }) => ({
		class: [
			// Flexbox and Alignment
			"flex items-center justify-center",
			"mx-auto",

			// Shape & Size
			"w-10 h-10",
			"rounded-full",
			"border-transparent border",

			// Colors
			{
				"font-bold text-olive bg-beige-light": context.date.today,
				"text-olive bg-transparent hover:bg-beige-light": !context.selected && !context.disabled && !context.date.today,
				"font-bold text-white bg-olive": context.selected && !context.disabled,
			},

			// States
			"focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-400/50",
			{
				"hover:bg-surface-100": !context.selected && !context.disabled,
				"hover:bg-primary-highlight-hover": context.selected && !context.disabled,
			},
			{
				"text-olive-light cursor-default": context.disabled,
				"cursor-pointer": !context.disabled,
			},
		],
	}),
	monthView: {
		class: [
			// Spacing
			"my-2",
		],
	},
	month: ({ context }) => ({
		class: [
			// Flexbox and Alignment
			"inline-flex items-center justify-center",

			// Size
			"w-1/3",
			"p-2",

			// Shape
			"rounded-md",

			// Colors
			{
				"text-olive bg-transparent": !context.selected && !context.disabled,
				"bg-highlight": context.selected && !context.disabled,
			},

			// States
			"focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-400/50",
			{
				"hover:bg-surface-100": !context.selected && !context.disabled,
				"hover:bg-primary-highlight-hover": context.selected && !context.disabled,
			},

			// Misc
			"cursor-pointer",
		],
	}),
	yearView: {
		class: [
			// Spacing
			"my-2",
		],
	},
	year: ({ context }) => ({
		class: [
			// Flexbox and Alignment
			"inline-flex items-center justify-center",

			// Size
			"w-1/3",
			"p-2",

			// Shape
			"rounded-md",

			// Colors
			{
				"text-olive bg-transparent": !context.selected && !context.disabled,
				"bg-highlight": context.selected && !context.disabled,
			},

			// States
			"focus:outline-none focus:outline-offset-0 focus:ring focus:ring-primary-400/50",
			{
				"hover:bg-surface-100": !context.selected && !context.disabled,
				"hover:bg-primary-highlight-hover": context.selected && !context.disabled,
			},

			// Misc
			"cursor-pointer",
		],
	}),
	timePicker: {
		class: [
			// Flexbox
			"flex",
			"justify-center items-center",

			// Borders
			"border-t-1",
			"border-solid border-olive",

			// Spacing
			"p-2",
		],
	},
	separatorContainer: {
		class: [
			// Flexbox and Alignment
			"flex",
			"items-center",
			"flex-col",

			// Spacing
			"px-2",
		],
	},
	separator: {
		class: [
			// Text
			"text-xl",
		],
	},
	hourPicker: {
		class: [
			// Flexbox and Alignment
			"flex",
			"items-center",
			"flex-col",

			// Spacing
			"px-2",
		],
	},
	minutePicker: {
		class: [
			// Flexbox and Alignment
			"flex",
			"items-center",
			"flex-col",

			// Spacing
			"px-2",
		],
	},
	secondPicker: {
		class: [
			// Flexbox and Alignment
			"flex",
			"items-center",
			"flex-col",

			// Spacing
			"px-2",
		],
	},
	ampmPicker: {
		class: [
			// Flexbox and Alignment
			"flex",
			"items-center",
			"flex-col",

			// Spacing
			"px-2",
		],
	},
	calendarContainer: "flex",
	calendar: "flex-auto border-l first:border-l-0 border-olive",
	buttonbar: {
		class: [
			// Flexbox
			"flex justify-between items-center",

			// Spacing
			"py-3 px-0",

			// Shape
			"border-t border-olive",
		],
	},
	transition: {
		enterFromClass: "opacity-0 scale-y-[0.8]",
		enterActiveClass: "transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]",
		leaveActiveClass: "transition-opacity duration-100 ease-linear",
		leaveToClass: "opacity-0",
	},
}
